import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthenticateWithTeamsToken } from 'src/app/store/session/authentication/authentication.actions';

@Injectable({
   providedIn: 'root',
})
export class TeamsSingleSignOnService {
   private teamsSSODebounceTimer: any;

   constructor(private store: Store) {}

   initialize(): void {
      console.trace('initializing MS Teams SSO service');
      window.addEventListener(
         'message',
         (event: MessageEvent<any>) => {
            // usually you'd validate event.origin so only trusted sites can send us messages.
            // since we don't know the origin of our teams app, we can't validate it.

            const data = event.data;

            // ignore unknown message formats, as well as ngxs actions
            if (data === null || data.type === null || data.type === 'ACTION') return;

            if (data.type === 'teams-sso' && data.teamsToken) this.handleTeamsSSOEvent(event);
         },
         false
      );
   }

   private handleTeamsSSOEvent(event: MessageEvent<any>): void {
      if (!(event.source instanceof MessagePort) && !(event.source instanceof ServiceWorker)) event.source.postMessage({ type: 'received-teams-sso' }, '*');

      if (this.teamsSSODebounceTimer) clearTimeout(this.teamsSSODebounceTimer);

      this.teamsSSODebounceTimer = setTimeout(() => this.store.dispatch(new AuthenticateWithTeamsToken(event.data.teamsToken)), 100);
   }
}
